import { render, staticRenderFns } from "./RealisationSidebarMailTab.vue?vue&type=template&id=7a920655&scoped=true"
import script from "./RealisationSidebarMailTab.vue?vue&type=script&lang=js"
export * from "./RealisationSidebarMailTab.vue?vue&type=script&lang=js"
import style0 from "./RealisationSidebarMailTab.vue?vue&type=style&index=0&id=7a920655&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a920655",
  null
  
)

export default component.exports